<template>
  <div>
    <el-dialog title="报销申请" :visible.sync="show" :before-close="close" center destroy-on-close
      :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="info" label-width="35%">
        <el-form-item label="编号" prop="eventId" v-if="type !== 'new'">
          <el-input disabled placeholder="编号" show-word-limit v-model="info.eventId" />
        </el-form-item>
        <el-form-item label="公司">
            <el-select v-model="companyId" placeholder="请选择公司" clearable style="width:100%" disabled>
              <el-option v-for="item in companyValueList" :key="item.companyId"  :label="item.companyName"
                :value="item.companyId">
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="所属部门" prop="deptName" :rules="{ required: true, message: '请选择部门', trigger: 'change' }">
          <el-select style="width: 100%" clearable id="selectInput" @clear="deptDataFilter" :disabled="type !== 'new'" v-model="info.deptName" filterable placeholder="请选择/输入" ref="searchSelect" :filter-method="(val) => deptDataFilter(val)">
            <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"> </el-option>
         </el-select>
        </el-form-item>
        <el-form-item label="收款人" prop="receiver">
          <el-input placeholder="请输入收款人" v-model="info.receiver" :disabled="type !== 'new'" @blur="queryData" />
        </el-form-item>
        <el-form-item label="费用类型" prop="feeType">
          <el-select v-model="info.feeType" filterable allow-create style="width: 100%" :disabled="type !== 'new'">
            <el-option v-for="item in feeTypeList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款方式" prop="paymentMethod">
          <el-select v-model="info.paymentMethod" @change="paymentMethodChange" style="width: 100%"
            :disabled="type !== 'new'">
            <el-option label="现金" :value="0" />
            <el-option label="转账" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="feeAmount">
          <el-input-number placeholder="请输入金额" style="width:80%" v-model="info.feeAmount" :min="0" :precision="2"
            :controls="false" :disabled="type !== 'new'" />
          <span style="margin-left: 20px;">元</span>
        </el-form-item>
        <template v-if="info.paymentMethod === 1">
          <el-form-item label="开户行" >
            <el-input placeholder="请输入开户行" v-model="info.bank" :disabled="type !== 'new'" />
          </el-form-item>
          <el-form-item label="开户行账户">
            <el-input placeholder="请输入开户行账户" v-model="info.bankAccount" :disabled="type !== 'new'" />
          </el-form-item>
          <el-form-item label="合同总金额">
            <el-input-number placeholder="请输入金额" style="width:80%" v-model="info.contactTotalAmount" :min="0" :precision="2"
              :controls="false" :disabled="type !== 'new'" />
            <span style="margin-left: 20px;width:80%">元</span>
          </el-form-item>
          <el-form-item label="累计已付">
            <el-input-number placeholder="请输入金额" style="width:80%" v-model="info.payedTotal" :min="0" :precision="2"
              :controls="false" :disabled="type !== 'new'" />
            <span style="margin-left: 20px;width:80%">元</span>
          </el-form-item>
          <el-form-item label="本次支付">
            <el-input-number placeholder="请输入金额" style="width:80%" v-model="info.payedThisTime" :min="0" :precision="2"
              :controls="false" :disabled="type !== 'new'" />
            <span style="margin-left: 20px">元</span>
          </el-form-item>
          <el-form-item label="剩余未付">
            <el-input-number placeholder="请输入金额" style="width:80%" v-model="info.payedLeft" :min="0" :precision="2"
              :controls="false" />
            <span style="margin-left: 20px">元</span>
          </el-form-item>
        </template>
        <el-form-item label="关联合同" prop="contractRelFlag">
          <el-select v-model="info.contractRelFlag" style="width: 100%" :disabled="type !== 'new'">
            <el-option label="否" :value="0" />
            <el-option label="是" :value="1" />
          </el-select>
        </el-form-item>
        <template v-if="info.contractRelFlag === 1">
          <el-form-item label="合同编号" prop="contractNumber">
            <el-select v-model="info.contractNumber" filterable :disabled="type !== 'new'"
              @change="contractNumberChange" :filter-method="dataFilter" clearable @clear="dataFilter"
              style="width:100%" placeholder="请输入/选择">
              <el-option v-for="item in contractList" :key="item.id" :label="item.contractNumber"
                :value="item.contractNumber" />
            </el-select>
          </el-form-item>
          <el-form-item label="合同名称" prop="contractName">
            <el-input v-model="info.contractName" :disabled="type !== 'new'" placeholder="请选择合同" />
          </el-form-item>
          <el-form-item label="合同期限" prop="contractTerm">
            <el-input v-model="info.contractTerm" :disabled="type !== 'new'" placeholder="请选择合同" />
            <!-- <el-date-picker
            v-model="info"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker> -->
          </el-form-item>
        </template>
        <el-form-item label="上传发票" prop="invoiceUrl">
          <!-- 
          :before-upload="beforeAvatarUpload"
          accept="image/jpeg,image/jpg,image/png,application/pdf,application/zip,.zip"
        -->
          <el-upload :class="{
            'avatar-uploader-none': type !== 'new',
          }" :disabled="type !== 'new'" action="" :http-request="httpRequest" :file-list="info.invoiceUrl"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" show-file-list>
            <el-button size="small" type="primary" :disabled="type !== 'new'">点击上传</el-button>
          </el-upload>
          <!-- <el-row class="uploadImage">
            <div class="block">
              <div class="imageBox" v-for="(item,index) in getImageList" :key="index">
                <el-image 
                  class="elImage"
                  :src="item" 
                  :preview-src-list="getImageList"
                  >
                </el-image>
                <i class="el-icon-close"></i>
              </div>
            </div>
            <div class="block" >
             <el-link  v-for="(item,index) in getFileList" :key="index" type="primary" @click="handlePictureCardPreview(item)">{{item.name}}</el-link><i class="el-icon-close"></i>
            </div>
        </el-row> -->
        </el-form-item>
        <el-form-item label="情况说明">
          <el-input type="textarea"
          :rows="5"
          maxlength="100"
          show-word-limit
          :disabled="type !== 'new'" v-model="info.invoiceDescription" />
        </el-form-item>
        <template v-if="auditInfo.approvalFlag && type === 'Approval'">
          <el-form-item label="审核状态" prop="status" :rules="{
            required: true, message: '请选择审核状态', trigger: 'change'
          }">
            <el-select v-model="info.status" @change="handleRemark">
              <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item label="审核原因">
            <el-input type="textarea" :rows="5" maxlength="200" show-word-limit placeholder="请输入审核原因"
              v-model="info.remark"   @input="changeMessage($event)" />
          </el-form-item>
        </template>
        <template v-if="type === 'new' || info.status === 0">

          <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'"/>

          <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine' && type === 'new'">
            <el-select v-model="info.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'"
              style="width:100%">
              <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.auditInfo.auditPerson" disabled />
          </el-form-item>
        </template>
        <template v-if="activeName == 'queryMyAudit'">
          <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="info.status == '1'">
            <el-radio v-model="info.lastUserFlag" :label="1">是</el-radio>
            <el-radio v-model="info.lastUserFlag" :label="0">否</el-radio>
          </el-form-item>

          <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '1' && info.lastUserFlag == 0"/>

          <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="info.status == '1' && info.lastUserFlag == 0">
            <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
              <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
              </el-option>
            </el-select>
          </el-form-item>

          <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '3'"/>

          <el-form-item label="转办人" prop="nextAuditUserName" v-if="info.status == '3'">
                <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                  <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
        </template>
      </el-form>
      <!-- 步骤条 -->
      <review-process :processList="auditInfo.auditProcessEntityList" :createTime="auditInfo.createTime"
        :createUser="auditInfo.applyUser" :auditPerson="auditInfo.auditPerson" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEventForm()"
          v-if="type === 'new' || (auditInfo.approvalFlag && type === 'Approval')">提 交</el-button>
        <el-button type="primary" @click="addStagingForm()" v-if="(type === 'new' && info.status === 10) || (type === 'new' && info.status === '') ">暂 存</el-button>
        <el-button  @click="close()">关 闭</el-button>
      </div>
    </el-dialog>
    <el-image-viewer v-if="showImg" :url-list="getImageList" :on-close="colseImg" :zIndex="3000"
      :initialIndex="initialIndex" class="img-viewer-row" />
  </div>
</template>

<script>
import { uploadFile, fileDownload } from '@/api/user'
import { listCompanyfInfo } from '@/api/searchList'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { feeTypeList } from '@/utils/constants'
import { getApplyDetail, submitApply, auditAndNextUser, query, stagingApply } from '@/api/compApplyReimbursement'
import ReviewProcess from '@/components/ReviewProcess.vue'
import previewDetail from '@/components/Dialog/previewDetail'
// import { validBankAccount } from '@/assets/scripts/validate'
import { contractQuery } from '@/api/contract'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'
import companyDepts from '@/utils/companyDepts'
export default {
  mixins: [approval],
  data() {
    return {
      type: '',
      feeTypeList: feeTypeList,
      show: false,
      showImg: false,
      initialIndex: 0,
      id: '',
      companyId: '',
      info: {
        paymentMethod: 1,
        invoiceDescription: '',
        contractRelFlag: 0,
        contractName: '',
        contractTerm: '',
        receiver: '',
        feeType: '',
        feeAmount: '',
        bank: '',
        bankAccount: '',
        eventId: '',
        invoiceUrl: [],
        status: '',
        remark: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',

        contactTotalAmount: '',
        payedTotal: '',
        payedThisTime: '',
        payedLeft: '',
        companyId: '',
        deptName: '',
      },
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      },
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      rules: {
        receiver: [{ required: true, message: '请输入收款人', trigger: 'blur' }],
        companyId: [{ required: true, message: '请选择公司', trigger: 'change' }],
        feeType: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        feeAmount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        paymentMethod: [{ required: true, message: '请选择付款方式', trigger: 'change' }],
        contractRelFlag: [{ required: true, message: '请选择是否关联合同', trigger: 'change' }],
        contractNumber: [{ required: true, message: '请选择合同编号', trigger: ['change', 'blur'] }],
        bank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        // bankAccount: [
        //   { required: true, message: '请输入开户行账户', trigger: 'blur' },
        //   { validator: validBankAccount, trigger: 'blur' }
        // ],
        invoiceUrl: [{ required: true, message: '请上传发票', trigger: 'change' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
        deptName: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      // userInfoList: [],
      activeName: '',
      contractList: [],
      companyValueList: [],
      optionsFilter: [],
      baseDeptsNameList: ['财务部', '招商部', '综合部', '办公室', '工会', '人事部', '党支部'],
      deptNameList: [],
      deptOptionsFilter: [],
    }
  },
  components: {
    ElImageViewer,
    previewDetail,
    ReviewProcess
  },
  watch: {
    'info.contactTotalAmount': 'calcPayedLeft',
    'info.payedTotal': 'calcPayedLeft',
    'info.payedThisTime': 'calcPayedLeft'
  },
  computed: {
    getImageList() {
      let imageList = this.info.invoiceUrl.filter((item) => {
        return (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png')
      }).map(v => v.url)
      return imageList
    },
    getFileList() {
      let fileList = this.info.invoiceUrl.filter((item) => {
        return item.type === 'pdf'
      })
      return fileList
    }
  },
  mounted() {
    this.queryList()
    this.getContractList()
    this.getCompanyList()
    this.companyId = JSON.parse(localStorage.getItem('jiadingFangwu_current_company')).companyId
    this.info.companyId = JSON.parse(localStorage.getItem('jiadingFangwu_current_company')).companyId
    // console.log(this.info, 'info');
  },
  methods: {
    calcPayedLeft() {
      const total = Number(this.info.contactTotalAmount) || 0;
      const payed = Number(this.info.payedTotal) || 0;
      const payedThis = Number(this.info.payedThisTime) || 0;
      this.info.payedLeft = (total - payed - payedThis).toFixed(2);
    },
    deptDataFilter(val) {
      if (val) {
        this.info.deptName = val
        this.deptNameList = this.deptOptionsFilter.filter((item) => {
          if (item.includes(val) || item.toUpperCase().includes(val.toUpperCase())) {
            return true
          } else {
            this.$nextTick(() => {
              this.$refs['info'].clearValidate('deptName')
            })
          }
        })
      } else {
        this.deptNameList = this.deptOptionsFilter
      }
    },
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
     // 公司下拉框
    async getCompanyList() {
      let res = await listCompanyfInfo({})
      if (res && res.code === 0) {
        this.companyValueList = res.result
        const companyName = this.companyValueList.filter(i => i.companyId === this.companyId)[0].companyName
        if (companyName === '上海荣茂工贸有限公司') {
          this.baseDeptsNameList[1] = '营商服务部'
        }
        const keys = Object.keys(companyDepts)
        if (keys.includes(companyName)) {
          const newDepts = companyDepts[companyName]
          this.deptNameList = [...newDepts, ...this.baseDeptsNameList]
          this.optionsFilter = [...newDepts, ...this.baseDeptsNameList]
        } else {
          this.deptNameList = this.baseDeptsNameList
          this.optionsFilter = this.baseDeptsNameList
        }
      } else {
        this.deptNameList = this.baseDeptsNameList
        this.optionsFilter = this.baseDeptsNameList
      }
    },
    isTypeImage(item) {
      if (item.type === 'jpeg' || item.type === 'jpg' || item.type === 'png') {
        return true
      }
    },
    isTypeFile(item) {
      if (item.type === 'pdf') {
        return true
      }
    },
    // async queryList() {
    //   let res = await queryUserInfo({
    //     pageNum: 1,
    //     pageSize: 9999,
    //   })
    //   if (res.code === 0) {
    //     this.userInfoList = res.result.records
    //   }
    // },
    showDetails(type = 'new', id, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      if (id) {
        this.getDetails(id)
      }
    },
    getDetails(id) {
      this.id = id
      getApplyDetail({ id }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.handleStatus(result.createUser)
        this.companyId = result.companyId
        this.info = {
          receiver: result.receiver,
          feeType: result.feeType,
          feeAmount: result.feeAmount,
          bank: result.bank,
          bankAccount: result.bankAccount,
          eventId: result.eventId,
          paymentMethod: result.paymentMethod,
          invoiceDescription: result.invoiceDescription,
          contractRelFlag: result.contractRelFlag,
          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          payedTotal: result.payedTotal,
          contactTotalAmount: result.contactTotalAmount,
          payedThisTime: result.payedThisTime,
          payedLeft: result.payedLeft,
          companyId: result.companyId,
          deptName: result.deptName,
          contractName: result.contractName,
          contractNumber: result.contractNumber,
          contractTerm: result.contractTerm,
          status: result.approvalFlag === true ? '' : result.status,
          invoiceUrl: (result.invoiceUrl || '').split(',').map((item, index) => {
            let name = item.split('/')
            let type = name[2].split('.')[1]
            return {
              fileName: item,
              name: name[name.length - 1],
              url: process.env.VUE_APP_BASE_API + `/minio/getImage?fileName=${item}`,
              code: `invoiceUrl${index}`,
              type: type
            }
          }),
        }
        if (this.info.companyId === 0) {
          this.info.companyId = null
        } else {
          this.info.companyId = this.info.companyId
        }
        this.auditInfo = {
          auditProcessEntityList: result.auditProcessEntityList,
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditPerson: result.auditPerson,
          approvalFlag: result.approvalFlag
        }
        if (this.type === 'new' && this.info && this.info.auditPersonId && result.status === 10) {
          this.info.auditPersonId = ''
        }
      })
    },
    close() {
      this.info = {
        receiver: '',
        feeType: '',
        feeAmount: '',
        bank: '',
        status: '',
        bankAccount: '',
        eventId: '',
        paymentMethod: 1,
        invoiceDescription: '',
        contractRelFlag: 0,
        contractName: '',
        contractTerm: '',
        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        payedTotal: '',
        contactTotalAmount: '',
        payedThisTime: '',
        payedLeft: '',
        companyId: this.info.companyId,
        deptName: '',
        invoiceUrl: []
      }
      this.auditInfo = {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
      // this.contractList = []
      this.show = false
    },
    addEventForm() {
      this.$refs.form.validate((vaild) => {
        console.log(this.info.contractNumber);
        // if (this.info.contractNumber) {
        //   console.log('1111');
        //   this.$refs['form'].clearValidate('contractNumber');
        // }
        if (vaild) {
          if (this.type === 'new') {
            submitApply({
              receiver: this.info.receiver,
              feeType: this.info.feeType,
              feeAmount: this.info.feeAmount,
              bank: this.info.bank,
              bankAccount: this.info.bankAccount,
              paymentMethod: this.info.paymentMethod,
              invoiceDescription: this.info.invoiceDescription,
              contractRelFlag: this.info.contractRelFlag,
              contractName: this.info.contractName,
              contractTerm: this.info.contractTerm,
              contractNumber: this.info.contractNumber,
              invoiceUrl: (this.info.invoiceUrl || []).map((item) => { return item.fileName }).join(','),
              auditPersonId: this.info.auditPersonId,
              payedTotal: this.info.payedTotal,
              contactTotalAmount: this.info.contactTotalAmount,
              payedThisTime: this.info.payedThisTime,
              payedLeft: this.info.payedLeft,
              companyId: this.info.companyId,
              deptName: this.info.deptName,
              eventId: this.info.eventId,
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('申请已提交')
              this.$emit('addSuccess')
              this.close()
            })
          } else if (this.auditInfo.approvalFlag) {
            auditAndNextUser({
              id: this.id,
              remark: this.info.remark,
              status: this.info.status,
              lastUserFlag: this.info.lastUserFlag,
              nextAuditUserName: this.info.nextAuditUserName,
            }).then(res => {
              const { code } = res
              if (code !== 0) return
              this.$message.success('审批成功！')
              this.$emit('addSuccess')
              this.close()
            })
          }
        }
      })
    },
    // 文件上传
    async httpRequest(param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      const { code, result, message } = await uploadFile(fd)
      if (code === 0) {
        let name = result.split('/')
        let type = name[2].split('.')[1]
        this.info.invoiceUrl.push({
          fileName: result,
          name: name[name.length - 1],
          url: process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + result,
          code: result,
          type: type
        })
        this.$refs.form.validateField('invoiceUrl')
      } else {
        this.$message.error(message)
      }
    },
    // // 上传前文件格式校验
    // beforeAvatarUpload (file) {
    //    // 格式过滤
    //   let fileType = ['png', 'jpg', 'jpeg', 'pdf', 'zip'] 
    //   let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
    //   const extension = fileType.indexOf(testmsg) >= 0
    //   if (!extension) {
    //     this.$message.error('仅支持png, jpg, jpeg, pdf, zip格式')
    //   }
    //   return extension
    // },
    // 图片预览
    async handlePictureCardPreview(file) {
      if (this.isTypeImage(file)) {
        this.showImg = true
        this.initialIndex = this.getImageList.indexOf(file.url) > -1 ? this.getImageList.indexOf(file.url) : 0
      } else {
        let componentProps = {
          curStatus: '',
          pdfFile: file
        }
        let dialogProps = {
          title: '文件预览', 
          width: '80%', 
          footer: true
        }
        if (['pdf', 'PDF'].includes(file.type)) {
          componentProps.curStatus = 'pdf'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['doc', 'docx'].includes(file.type)) {
          componentProps.curStatus = 'doc'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        if (['xlsx', 'xls'].includes(file.type)) {
          componentProps.curStatus = 'xls'
          this.$dialog(previewDetail, componentProps, dialogProps)
          return
        }
        let res = await fileDownload(file.url.split('=')[1])
        let blob = new Blob([res.data], { type: res.data.type })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = file.name
        link.click()
      }
      // let fileType = ['png', 'jpg', 'jpeg'] 
      // let imageList = this.getImageList.find((item) => {
      //   let testmsg = item.name.substring(item.name.lastIndexOf('.') + 1)
      //   const extension = fileType.indexOf(testmsg) >= 0
      //   if (extension) return item
      // })
      // if (imageList)
      // this.initialIndex = this.getImageList.indexOf(row.url) > -1 ? this.getImageList.indexOf(row.url) : 0
      // this.showImg = true
    },
    colseImg() {
      this.showImg = false
    },
    // 图片删除
    handleRemove(row) {
      this.info.invoiceUrl = this.info.invoiceUrl.filter((item) => item.url !== row.url)
    },
    paymentMethodChange(value) {
      if (value) {
        this.info = {
          ...this.info,
          bank: '',
          bankAccount: ''
        }
      }
    },
    // 开户行、账号有历史记录则自动带出
    queryData() {
      if (this.info.paymentMethod === 0) return
      query({
        receiver: this.info.receiver,
        pageNum: 1,
        pageSize: 1
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          let data = result.records?.[0] || {}
          this.info = {
            ...this.info,
            bank: data.bank || this.info.bank || '',
            bankAccount: data.bankAccount || this.info.bankAccount || '',
          }
        }
      })
    },
    // 合同编号模糊查询
    remoteMethod(value) {
      clearTimeout(this.timer)
      if (value) {
        this.timer = setTimeout(() => {
          this.getContractList(value)
        }, 500)
      } else {
        this.contractList = []
      }
    },
    dataFilter(val) {
      if (val) {
        if (this.optionsFilter.length > 0) {
          this.contractList = this.optionsFilter.filter((item) => {
            if (item.contractNumber.includes(val) || item.contractNumber.toUpperCase().includes(val.toUpperCase())) {
              return true
            } else {
              // this.info.contractNumber = val;
              this.$set(this.info, 'contractNumber', val)
              this.info.contractName = '';
              this.info.contractTerm = '';
              this.$nextTick(() => {
                this.$refs['form'].clearValidate('contractNumber');
              })
            }
          })
        } else {
          this.$set(this.info, 'contractNumber', val)
          this.info.contractName = '';
          this.info.contractTerm = '';
          this.$nextTick(() => {
            this.$refs['form'].clearValidate('contractNumber');
          })
        }
      } else {
        this.contractList = this.optionsFilter;
      }
    },
    getContractList() {
      contractQuery({
        pageNum: 1,
        pageSize: 9999,
        // contractStatus: 7,
        // contractNumber: value
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.contractList = result.records
        this.optionsFilter = result.records
      })
    },
    contractNumberChange(value) {
      // console.log('111111');
      if (!value) return
      let data = this.contractList.find(item => item.contractNumber === value)
      // console.log(data);
      this.info = {
        ...this.info,
        contractName: data.contractName,
        contractTerm: `${data.contractStartDate}至${data.contractEndDate}`
      }
    },
    async addStagingForm() {
      this.$refs.form.validate(async(vaild) => {
      if (vaild) {
          const { code, message } = await stagingApply({ 
            receiver: this.info.receiver,
              feeType: this.info.feeType,
              feeAmount: this.info.feeAmount,
              bank: this.info.bank,
              bankAccount: this.info.bankAccount,
              paymentMethod: this.info.paymentMethod,
              invoiceDescription: this.info.invoiceDescription,
              contractRelFlag: this.info.contractRelFlag,
              contractName: this.info.contractName,
              contractTerm: this.info.contractTerm,
              contractNumber: this.info.contractNumber,
              invoiceUrl: (this.info.invoiceUrl || []).map((item) => { return item.fileName }).join(','),
              auditPersonId: this.info.auditPersonId,
              payedTotal: this.info.payedTotal,
              contactTotalAmount: this.info.contactTotalAmount,
              payedThisTime: this.info.payedThisTime,
              payedLeft: this.info.payedLeft,
              companyId: this.info.companyId,
              deptName: this.info.deptName,
              eventId: this.info.eventId,
             })
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  min-width: 550px;
  width: 30%;

  .el-dialog__body {
    max-height: 50vh;
    overflow-y: scroll;
  }
}

.img-viewer-row {
  height: 100vh;
  z-index: 3000 !important;

  // 防止上传照片高度宽度过大
  /deep/ .el-image-viewer__img {
    max-height: 80vh;
    max-width: 80vw;
  }
}

.avatar-uploader-none {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}

//   /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//   }
//   /deep/ .el-upload:hover {
//     border-color: #409EFF;
//   }
//   .avatar-uploader-icon {
//     font-size: 28px;
//     color: #8c939d;
//     width: 178px;
//     height: 178px;
//     line-height: 178px;
//     text-align: center;
//   }
//   .avatar {
//     width: 178px;
//     height: 178px;
//     display: block;
//   }
// }
.uploadImage {
  margin-top: 20px;

  .block {
    display: flex;
    flex-wrap: wrap;

    .imageBox {
      position: relative;

      .el-icon-close {
        position: absolute;
        top: -5px;
        right: 2px;
      }
    }

    .elImage {
      width: 100px;
      height: 100px;
      margin-right: 20px;
      position: relative;

      img {
        width: 120px;
        height: 120px;
        margin-right: 10px;
      }
    }

  }
}
</style>
